<template>
  <div
    id="crumbs"
    :class="{ 'crumbs-na-agent': auth.user.role === 7 }"
    @mouseenter="openPresetMenu"
    @mouseleave="closePresetMenu"
  >
    <div class="btn-group btn-group-sm" role="group" aria-label="First group">
      <button
        type="button"
        @mouseenter="openSubWSecond('na')"
        @mouseleave="closeSubWSecond('na')"
        class="btn btn-na"
      >
        <!--        @click="openSubW('regular', 'na')"-->

        <!--        :class="{-->
        <!--        'greyed-out':-->
        <!--        selectedMainTab !== 'clients' && greyOutTag('na', selectedMainTab)-->
        <!--        }"-->
        <div
          v-if="!filtersNa.naAll"
          v-tooltip.right="{ content: getContentForTooltip('na') }"
        >
          {{ stats == 0 ? "NA" : kFormatter(stats)
          }}{{ totalSum > 0 && stats != 0 ? "/" + totalSum : "" }}
        </div>
        <div v-if="filtersNa.naAll">
          {{ statsNaAll == 0 ? "NA ALL" : kFormatter(statsNaAll)
          }}{{ totalSum > 0 && statsNaAll != 0 ? "/" + totalSum : "" }}
        </div>

        <div
          class="bb-sub-menu"
          v-if="checkSubMenuMode('na') && !checkIfSecondView('na')"
        >
          <div
            class="bb-sub-menu-ms"
            @click.stop="openMsW('na')"
            v-if="auth.user.role !== 7"
            v-tooltip="{ content: `Open multi-select` }"
          >
            <div class="na-color bb-item">
              <i class="fas fa-bars"></i>
            </div>
            <div class="fake-column na-color"></div>
          </div>
          <div
            class="bb-sub-menu-reset"
            @click.stop="closeResetBtnW('na')"
            v-tooltip="{ content: `Reset` }"
          >
            <div class="na-color bb-item">
              <i class="fas fa-times"></i>
            </div>
            <div class="fake-column na-color"></div>
          </div>
        </div>
        <div class="bb-sub-menu" v-if="checkIfSecondView('na')">
          <div
            v-if="checkNumbersOfCalendarsSelected() === 1"
            class="bb-sub-menu-ms"
            @click.stop="mergeAllDates('na', 'regular', shortCutsToBlocks)"
            v-tooltip="{
              content: `Use the same selected dates with this new selection`
            }"
          >
            <!--          @click.stop="filterMultipleTags('regular', 'ld')"-->

            <div class="na-color bb-item">
              <div class="first-circle-tot"></div>
              <div class="second-circle-tot"></div>
              <div class="fake-column-tot na-color"></div>
            </div>
          </div>
          <div
            class="bb-sub-menu-reset"
            @click.stop="filterSingleTag('regular', 'na')"
            v-tooltip="{ content: `Disregard previous selections` }"
          >
            <div class="na-color bb-item">
              <div class="first-circle first-circle-right"></div>
              <div class="second-circle second-circle-right"></div>
              <div class="fake-column na-color"></div>
            </div>
          </div>
          <div
            class="bb-sub-menu-ms"
            @click.stop="filterMultipleTags('regular', 'na')"
            v-tooltip="{ content: `Productivity` }"
          >
            <div class="na-color bb-item">
              <div class="first-circle"></div>
              <div class="second-circle"></div>
              <div class="fake-column na-color"></div>
            </div>
          </div>
        </div>

        <div class="bb-title-wrapper upper-title">
          <span class="">na</span>
        </div>
        <div
          class="tags-dropdown"
          v-if="
            openTagDropdown &&
              mouseOver &&
              !checkSubMenuMode('na') &&
              !checkIfSecondView('na')
          "
        >
          <TagsDropdown
            :tag="tag"
            :multipleColumn="true"
            :btnColors="btnColors"
            @presetTrigger="emitPresetTrigger"
            @presetTriggerNaAll="emitPresetTriggerNaAll"
          />
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import UsersPermissionCheck from "../../../../../../mixins/user/auth/UsersPermissionCheck";
import { mapState } from "vuex";
import breadButtonsFunctionsUtil from "../../mixins/breadButtonsFunctionsUtil";
import calendarCheck from "../../../../../../mixins/tags/calendarCheck";
import TagsDropdown from "./TagsDropdown.component";
import { Globals } from "../../../../../../global_constants/constants";

export default {
  name: "BreadcrumbButton",
  components: {
    TagsDropdown
  },
  mixins: [UsersPermissionCheck, breadButtonsFunctionsUtil, calendarCheck],
  props: {
    ifCalendarSelected: {
      type: Object
    },
    filtersNa: {
      type: Object
    },
    selectedMainTab: {
      type: String,
      required: true
    },
    secondActiveTagsArr: {
      type: Array
    },
    activeTags: {
      type: Array
    },
    resetNaAllButtons: {
      type: Boolean
    },
    resetNaButtons: {
      type: Boolean
    },
    leftEar: {
      type: Number,
      required: false
    },
    variant: {
      type: String,
      required: false
    },
    bgColor: {
      type: String,
      required: true
    },
    txtColor: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    },
    disabledNaReg: {
      type: Boolean,
      required: false,
      default: () => false
    },

    stats: {
      type: Number,
      required: false
    },
    statsNaAll: {
      type: Number,
      required: false
    },

    statsRegNa: {
      type: Number,
      required: false
    },
    showOverall: {
      type: Boolean,
      required: false
    },
    earRight: {
      type: Boolean,
      required: false,
      default: false
    },
    earLeft: {
      type: Boolean,
      required: false,
      default: false
    },

    queryObject: {
      type: Object
    }
  },
  data() {
    return {
      tag: "na",

      calendarForPreset: "NA_TAG",
      mouseOver: false,
      btnColors: {
        backgroundColor: "#f4511e",
        color: "white"
      },
      openTagDropdown: false,
      showPopup: false,
      intervals: [],
      slideBtn: {
        na: false,
        na_all: false
      },
      resetBtn: {
        na_all: false,
        na: false
      },
      secondClick: {
        na_all: false,
        na: false
      },
      totalSum: "",
      secondView: true
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "totalSumForCrumbBtn",
      "shortCutsToBlocks",
      "generalQueryObject"
    ]),

    btnStyles() {
      return {
        "--bg-color": this.disabled ? "#546e7a" : this.bgColor,
        "--hover-on-disable":
          this.disabled || this.disabledNaReg ? "-3px" : "0px",
        "--font-weight": this.disabled ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    },

    btnRegNaStyles() {
      return {
        "--selling-group-bg-color": this.disabledNaReg ? "#546e7a" : "#910d6f",
        "--hover-on-disable": this.disabledNaReg ? "-3px" : "0px",
        "--font-weight": this.disabledNaReg ? "bold" : "normal",
        "--txt-color": this.txtColor,
        "--border-color": this.variant === "outlined" ? "#546e7a" : this.bgColor
      };
    }
  },

  methods: {
    closePresetMenu() {
      this.openTagDropdown = false;
      this.mouseOver = false;
    },
    openPresetMenu() {
      this.mouseOver = true;
      setTimeout(() => {
        if (this.mouseOver) {
          this.openTagDropdown = true;
        }
      }, Globals.ux.section.top_tag_menu.cal_presets_speed);
    },
    emitPresetTrigger(preset) {
      if (preset !== "ALL") {
        this.triggerPreset(this.calendarForPreset, preset);
      }
      if (preset) {
        this.openSubW("regular", "na");
      }
    },
    emitPresetTriggerNaAll(preset) {
      if (preset !== "ALL") {
        // let calendar = this.tag === "sc" ? "CA_F" : "CA_P"
        this.triggerPreset("NA_TAG", preset);
      } else {
        this.triggerPreset("NA_TAG", null);
      }
      this.$store.commit("clients/setClientsTableSelectedMainTab", "total");
      this.openSubW("na_all", "na");
    },
    getContentForTooltip(tag) {
      if (this.checkIfCalendarSelected()) {
        // if(this.checkSubMenuMode(tag)){
        return `Total no answer ${this.stats} clients from ${this.generalQueryObject.last_modified_na_from} to ${this.generalQueryObject.last_modified_na_to}`;
      } else {
        return `No answer ${this.stats} clients that are in the active group`;
      }
    },
    // checkSubMenuMode(btnTitle) {
    //   if (this.activeTags.includes(btnTitle)) {
    //     return true;
    //   }
    //   return false;
    // },
    // openMsW(emitTitle, btnTitle) {
    //   if(this.activeTags.includes(btnTitle)){
    //
    //   } else{
    //
    //     this.activeTags.push(btnTitle)
    //   }
    //   // if (!this.secondClick[btnTitle]) {
    //   //   this.$emit(emitTitle, this.secondClick[btnTitle]);
    //   //   this.resetBtn[btnTitle] = true;
    //   //   this.secondClick[btnTitle] = true;
    //   // } else {
    //   //   this.$emit("regular", this.secondClick[btnTitle]);
    //   //   this.secondClick[btnTitle] = false;
    //   // }
    //
    //
    // },

    openSlideBtn(id) {
      this.slideBtn[id] = true;
    },
    closeSlideBtn(id) {
      this.slideBtn[id] = false;
    },
    closeResetBtn(btnTitle) {
      this.resetBtn[id] = false;
      this.$emit("reset");
    },
    emitTrigger(title) {
      this.$emit(title, this.secondClick);
      this.resetBtn[title] = true;
    },
    kFormatter: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      }
    },

    kFormatterEar: function(num) {
      if (num) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      }
      // return "ALL";
    }
  },
  mounted() {
    // $(document).ready(function() {
    //   $('[data-toggle="tooltip"]').tooltip({ container: "body" });
    //
    //   $('[data-toggle="tooltip"]').tooltip();
    // });
  },
  watch: {
    totalSumForCrumbBtn: function() {
      this.totalSum = this.totalSumForCrumbBtn;
    }
    /*    leftEar: function() {
              if (this.leftEar > 0) {
                this.intervals.push(
                  setInterval(() => {
                    const yellow = "#fbc02d";
                    const red = "#c62828";
                    const grey = "#546e7a";
                    this.yellow = grey;
                    // let that = this;
                    setTimeout(() => {
                      this.yellow = yellow;
                    }, 1500);
                  }, 3000)
                );
              }
              if (this.leftEar < 1) {
                for (let i = 0; i < this.intervals.length; i++) {
                  clearInterval(this.intervals[i]);
                }
                this.intervals = [];
              }
            }*/
  }
};
</script>

<style lang="scss" scoped>
$btnColor: #f4511e;
$btnColorChild: #d53f10;
$color: var(--bg-color);
$depositColor: var(--deposits-bg-color);
$comingColor: var(--coming-bg-color);
$ccDeclineColor: var(--selling-group-bg-color);
$borderColor: var(--border-color);
$hoverColor: #546e7a;
$fontWeight: var(--font-weight);
.tag-wrapper {
  display: inline;
  position: relative;
}

#crumbs {
  position: relative;
  /*margin-right: 10px;*/
}

#crumbs a {
  display: block;
  float: left;
  height: 20px;
  width: 70px; //70px;
  line-height: 16pt;
  background: $color;
  padding: 0 3px 0 4px;
  border-color: $borderColor;
  position: relative;
  margin: 0 20px 0 0;
  text-align: center;
  text-decoration: none;
  color: var(--txt-color);
  font-size: 12px; //9pt;
  font-family: "Montserrat" !important;
  font-weight: 500; /*$fontWeight;*/
  /*border-bottom-left-radius: 5px;*/
  /*border-bottom-right-radius: 5px;*/
  /*border-top-left-radius: 5px;*/
  top: var(--hover-on-disable);
}

#crumbs a:hover {
  top: -3px;
}

.dot-right {
  height: 20px;
  width: 32px;
  border: 1px solid #910d6f;
  border-radius: 5px;

  color: #910d6f;
  /*border-radius: 50%;*/
  bottom: 20px;
  right: 0px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.dot-right:hover {
  /*background-color: #90a4ae;*/
}

.dot-left {
  height: 26px;
  width: 26px;
  background-color: #3d890d; /*#fbc02d;*/

  /*color: white;*/
  border-color: $borderColor;
  border-radius: 50%;
  bottom: 8px;
  left: -8px;
  position: absolute;
  font-weight: 500;
  font-size: 12px;
}

.dot-left:hover {
  /*background-color: #90a4ae;*/
}

.btn-na {
  font-size: 10px;
  color: #ffffff;
  background-color: $btnColor;
  border-color: $btnColor;
  transition: all 0.2s ease-in;
  width: 100%;
  border-radius: 5px !important;
  /*margin-right: 10px;*/
}

.btn-na:hover,
.btn-na:focus,
.btn-na:active,
.btn-na.active,
.open .dropdown-toggle.btn-na {
  outline: none;
}

.btn-na:focus,
.btn-na:active,
.btn-na.active {
  /*-moz-box-shadow: inset 0 0 5px 5px #fa8100;*/
  /*-webkit-box-shadow: inset 0 0 5px 5px#fa8100;*/
  /*box-shadow: inset 0 0 5px 5px #fa8100;*/
  z-index: 0 !important;
}

.btn-na:hover {
  outline: none;
  z-index: 1 !important;
  cursor: default;
}

.btn-na:nth-of-type(2) {
  /*COming calls*/
  background-color: #d53f10;
  border-color: #d53f10;
  /*<!--border-bottom-color: $btnColor;-->*/
  /*<!--border-top-color: $btnColor;-->*/
  /*<!--border-right-color: $btnColor;-->*/
}

.btn-na:nth-of-type(3) {
  /*Today call*/
  background-color: #fa8100;
  border-color: #fa8100;
}

.btn-na:nth-of-type(4) {
  /* Auto Missed calls*/
  background-color: #c62828;
  border-color: #c62828;
}

.btn-na:nth-of-type(5) {
  background-color: #af4448;
  border-color: #af4448;
}

.slide-btn {
  position: absolute;
  top: 24px;
  background-color: inherit;
  width: 105%;
  left: -1px;
  border-radius: 0px 0px 30px 0px;
}

.reset-btn {
  position: absolute;
  top: -8px;
  right: 0px;
  color: #333;
  transition: all 0.2s ease-in;
}

.reset-btn:hover {
  position: absolute;
  transform: scale(1.3);
  color: red;
}

.arrow {
  position: absolute;
  top: 13px;
  left: -3px;
  /*transform: translate(50%,50%);*/
  transform: rotate(90deg);
}

.arrow span {
  display: block;
  width: 6px;
  height: 6px;
  border-bottom: 2px solid white;
  border-right: 2px solid white;
  transform: rotate(45deg);
  margin: -10px;
  animation: animate 2s infinite;
}

.arrow span:nth-child(2) {
  animation-delay: -0.2s;
}

.arrow span:nth-child(3) {
  animation-delay: -0.4s;
}

@keyframes animate {
  0% {
    opacity: 0;
    transform: rotate(45deg) translate(-5px, -5px);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(45deg) translate(0px, 0px);
  }
}

.btn-group-sm {
  /*display: flex;*/
}

#crumbs .btn-group-sm {
  display: flex;
}

.btn-na:hover {
  transform: scale(1.1);
}

span.bb-title {
  position: absolute;
  top: 25px;
  color: black;
  left: 0px;
  font-size: 8px;
}

div.bb-title-wrapper {
  //position: absolute;
  color: white;
  font-size: 8px;
  width: 100%;
  top: 25px;
  left: 0px;
  text-align: center;
}

.crumbs-na-agent {
  width: 103%;
}

.upper-title {
  text-transform: uppercase;
}

.bb-sub-menu {
  position: absolute;
  width: 100%;
  top: -26px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  height: 30px;
  cursor: pointer;
}

.bb-sub-menu-reset,
.bb-sub-menu-ms {
  /*padding: 3px 5px;*/
  /*<!--background-color: $btnColor;-->*/
  border-radius: 4px;
  height: 30px;
  width: 20px;
}

.first-circle {
  background-color: white;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
}

.second-circle {
  background-color: white;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.first-circle-right {
  /*left: 45px;*/
  background-color: white;
}

.second-circle-right {
  /*left: 50px;*/
  background-color: inherit;
  border: 1px solid white;
}

.na-all-color {
  background-color: $btnColorChild;
}

.greyed-out {
  opacity: 0.5;
  pointer-events: none;
}

.bb-item {
  height: 20px;
  width: 20px;
  border-radius: 5px;
  padding-top: 3px;
  position: relative;
}

.fake-column {
  width: 8px;
  height: 10px;
  margin-left: 6px;
}

div.second-circle + div.fake-column {
  margin-top: 14px;
}

.na-color {
  background-color: $btnColor;
}

.first-circle-tot {
  background-color: inherit;
  height: 10px;
  width: 10px;
  position: absolute;
  border-radius: 50%;
  left: 2px;
  top: 8px;
  border: 1px solid white;
}

.second-circle-tot {
  border: 1px solid white;
  background-color: inherit;
  height: 8px;
  width: 8px;
  position: absolute;
  border-radius: 50%;
  left: 8px;
  top: 3px;
}

.fake-column-tot {
  width: 8px;
  /*height: 10px;*/
  height: 23px;
  margin-left: 6px;
}

.tags-dropdown {
  /*padding: 3px 5px;*/
  position: absolute;
  /*background-color: wheat;*/
  top: 38px;
  left: 0px;
  z-index: 1;
  border-radius: 5px;
  width: 100%;
}
</style>
